(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["board-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var els = document.querySelectorAll('.board-reveal');
      els.forEach(function (el) {
        if (el.dataset.brInit) return;
        el.dataset.brInit = '1';

        if (!('IntersectionObserver' in window)) {
          el.classList.add('is-in');
          return;
        }
        var io = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                obs.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15 }
        );
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function markPlaying(video) {
      var media = video.closest('.community-reels__media');
      if (media) media.classList.add('community-reels__media--playing');
    }

    function hideBrokenPosters() {
      document.querySelectorAll('.community-reels__poster').forEach(function (img) {
        if (img.dataset.crInit) return;
        img.dataset.crInit = '1';
        function fail() { img.classList.add('community-reels__poster--hidden'); }
        if (img.complete && !img.naturalWidth) fail();
        img.addEventListener('error', fail);
      });
    }

    function hideBrokenAvatars() {
      document.querySelectorAll('.community-reels__avatar').forEach(function (img) {
        if (img.dataset.crAv) return;
        img.dataset.crAv = '1';
        function fail() { img.classList.add('community-reels__avatar--hidden'); }
        if (img.complete && !img.naturalWidth) fail();
        img.addEventListener('error', fail);
      });
    }

    function playInView(video) {
      if (!video.src && video.dataset.src) video.src = video.dataset.src;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function init() {
      hideBrokenPosters();
      hideBrokenAvatars();
      var videos = document.querySelectorAll('.community-reels__video[data-src]');
      if (!videos.length) return;

      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) {
          if (v.dataset.crVid) return;
          v.dataset.crVid = '1';
          v.addEventListener('playing', function () { markPlaying(v); });
          playInView(v);
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              playInView(v);
            } else if (!v.paused) {
              v.pause();
            }
          });
        },
        { rootMargin: '200px 200px', threshold: 0.2 }
      );

      videos.forEach(function (v) {
        if (v.dataset.crVid) return;
        v.dataset.crVid = '1';
        v.addEventListener('playing', function () { markPlaying(v); });
        io.observe(v);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fathers-day-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    var media = (scope || document).querySelector('.fd-home-media');
    if (!media || media.dataset.bound) return;
    media.dataset.bound = '1';
    var v = media.querySelector('.fd-home-video');
    var replay = media.querySelector('.fd-home-replay');
    if (!v) return;

    var play = function () {
      if (!v.src && v.dataset.src) { v.src = v.dataset.src; }
      media.classList.remove('is-ended');
      var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
    };

    // Plays once, then freezes on the last frame (no loop) and reveals the replay control.
    v.addEventListener('ended', function () { media.classList.add('is-ended'); });
    if (replay) {
      replay.addEventListener('click', function () { try { v.currentTime = 0; } catch (e) {} play(); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(); io.disconnect(); } });
      }, { rootMargin: '200px' });
      io.observe(v);
    } else { play(); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fathers-day-landing"] && !Shopify.designMode) return;
  try {
    
// Hide Shopify Inbox chat on this landing only — its bubble (z-index max) injects
// its own CSS after ours, so we force display:none inline (inline !important wins).
// Re-applies via observer + short retry because the widget loads asynchronously.
(function () {
  function hideChat() {
    var c = document.getElementById('ShopifyChat') || document.querySelector('inbox-online-store-chat');
    if (c) {
      // opacity:0 on the host can't be reverted by inner elements; pointer-events
      // kills clicks. display/visibility as belt-and-suspenders.
      c.style.setProperty('opacity', '0', 'important');
      c.style.setProperty('pointer-events', 'none', 'important');
      c.style.setProperty('visibility', 'hidden', 'important');
      c.style.setProperty('display', 'none', 'important');
    }
  }
  hideChat();
  var tries = 0;
  var iv = setInterval(function () { hideChat(); if (++tries > 20) clearInterval(iv); }, 300);
  if (window.MutationObserver) {
    try { new MutationObserver(hideChat).observe(document.body, { childList: true }); } catch (e) {}
  }
})();

// Story video: lazy-load + autoplay (muted) once it scrolls into view, plays a
// single time and freezes on the last frame. Replay button restarts it. The
// button is visible before playing / after it ends, and also covers the case
// where autoplay is blocked. Works on desktop + mobile.
(function () {
  var media = document.querySelector('.ttb-fd .story-media');
  if (!media) return;
  var v = media.querySelector('.story-video');
  var btn = media.querySelector('.story-replay');
  if (!v) return;

  function play() {
    if (!v.getAttribute('src') && v.dataset.src) { v.setAttribute('src', v.dataset.src); v.load(); }
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }
  v.addEventListener('playing', function () { media.classList.add('is-playing'); });
  v.addEventListener('ended', function () { media.classList.remove('is-playing'); });
  if (btn) { btn.addEventListener('click', function () { try { v.currentTime = 0; } catch (e) {} play(); }); }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { play(); io.unobserve(v); }
      });
    }, { threshold: 0.4 });
    io.observe(v);
  } else {
    play();
  }
})();

(function () {
  // Scope to the most recent .ttb-fd on the page
  var scopes = document.querySelectorAll('.ttb-fd');
  var scope = scopes.length ? scopes[scopes.length - 1] : document;

  // Audience swap via UTM ?aud=american|latino (default latino = higher CTR in Spanish per TTB data)
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('aud') === 'american') {
      var hero = scope.querySelector('#heroImg');
      if (hero && hero.dataset.audAmerican) {
        hero.removeAttribute('srcset');
        hero.src = hero.dataset.audAmerican;
      }
      var moment = scope.querySelector('#momentImg');
      if (moment && moment.dataset.audAmerican) {
        moment.removeAttribute('srcset');
        moment.src = moment.dataset.audAmerican;
      }
    }
  } catch (e) {}

  // Announce bar — rotating messages + date-aware rescue swap
  var track = scope.querySelector('#announceTrack');
  if (track) {
    var all = Array.prototype.slice.call(track.querySelectorAll('.announce-msg'));
    var rescue = track.querySelector('[data-msg="rescue"]');
    var deadlineIso = track.getAttribute('data-deadline') || '2026-06-09T23:59:00-07:00';
    var deadline = new Date(deadlineIso);
    var pastDeadline = new Date() > deadline;

    var pool;
    if (pastDeadline && rescue) {
      pool = [rescue, all[1], all[2]];
    } else {
      pool = [all[0], all[1], all[2]];
      if (rescue) rescue.style.display = 'none';
    }
    pool = pool.filter(Boolean);

    all.forEach(function (m) { m.classList.remove('active'); });
    if (pool[0]) pool[0].classList.add('active');

    var i = 0;
    if (pool.length > 1) {
      setInterval(function () {
        var current = pool[i];
        i = (i + 1) % pool.length;
        var next = pool[i];
        if (current) {
          current.classList.add('exiting');
          current.classList.remove('active');
          setTimeout(function () { current.classList.remove('exiting'); }, 500);
        }
        if (next) next.classList.add('active');
      }, 4500);
    }
  }

  // §4 Community reels — lazy-load + autoplay (muted) only while in view
  try {
    var reelVids = scope.querySelectorAll('.ig-video[data-src]');
    if (reelVids.length) {
      scope.querySelectorAll('.ig-poster').forEach(function (img) {
        function fail() { img.classList.add('is-broken'); }
        if (img.complete && !img.naturalWidth) fail();
        img.addEventListener('error', fail);
      });
      var playReel = function (v) {
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      };
      var markReel = function (v) {
        var card = v.closest('.ig-card'); if (card) card.classList.add('is-playing');
      };
      if ('IntersectionObserver' in window) {
        var reelIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) playReel(v); else if (!v.paused) v.pause();
          });
        }, { rootMargin: '200px 200px', threshold: 0.2 });
        reelVids.forEach(function (v) { v.addEventListener('playing', function () { markReel(v); }); reelIO.observe(v); });
      } else {
        reelVids.forEach(function (v) { v.addEventListener('playing', function () { markReel(v); }); playReel(v); });
      }
    }
  } catch (e) {}
})();
// In-page buy: engraving toggle + AJAX add-to-cart + slide-in cart drawer.
// Uses event delegation on document so it survives DOM replacement (theme
// editor section re-render / dev-server hot reload) and late script execution.
(function () {
  var ROOT = document.querySelector('.ttb-fd');
  var CART = (ROOT && ROOT.getAttribute('data-cart-url')) || '/cart';
  // Father's Day promo: every board ships with a free bottle of board oil.
  // The oil is auto-added alongside the board; a Shopify automatic BXGY discount
  // ("buy a board → 1 oil free") zeroes its price at the cart/checkout level.
  var OIL_VID = (ROOT && ROOT.getAttribute('data-oil-vid')) || '';
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function syncMode(form) {
    var checked = form.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    var engraved = checked.value === 'engraved';
    form.querySelectorAll('.eng-opt').forEach(function (l) { l.classList.toggle('is-active', !!l.querySelector('input:checked')); });
    var field = form.querySelector('.eng-field'); if (field) field.hidden = !engraved;
    var price = form.querySelector('[data-price]'); if (price && price.dataset.engraved) price.textContent = engraved ? price.dataset.engraved : price.dataset.plain;
  }
  function initForms() { document.querySelectorAll('.ttb-fd .board-buy').forEach(syncMode); }

  function openCart() { var c = document.getElementById('fdCart'); if (!c) return; c.classList.add('is-open'); c.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { var c = document.getElementById('fdCart'); if (!c) return; c.classList.remove('is-open'); c.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function renderCart(cart) {
    var itemsEl = document.getElementById('fdCartItems');
    var subEl = document.getElementById('fdCartSubtotal');
    if (!itemsEl || !subEl) return;
    itemsEl.innerHTML = '';
    cart.items.forEach(function (it) {
      var free = it.final_line_price === 0;
      var eng = (it.properties && it.properties.Engraving) ? '<div class="fd-ci-eng">✎ "' + it.properties.Engraving + '"</div>' : '';
      var opt = (it.variant_title && it.variant_title.indexOf('No Engraving') === -1) ? '<div class="fd-ci-opt">' + it.variant_title + '</div>' : '';
      var img = it.image ? '<img src="' + it.image + '" alt="" width="64" height="64">' : '';
      var meta = free ? '<div class="fd-ci-gift">🎁 Father’s Day gift</div>' : '<div class="fd-ci-opt">Qty ' + it.quantity + '</div>';
      var priceHtml;
      if (free) {
        priceHtml = '<span class="fd-ci-was">' + money(it.original_line_price) + '</span><span class="fd-ci-free">FREE</span>';
      } else if (it.final_line_price < it.original_line_price) {
        priceHtml = '<span class="fd-ci-was">' + money(it.original_line_price) + '</span>' + money(it.final_line_price);
      } else {
        priceHtml = money(it.final_line_price);
      }
      itemsEl.insertAdjacentHTML('beforeend',
        '<div class="fd-ci' + (free ? ' is-free' : '') + '">' + img +
        '<div class="fd-ci-info"><div class="fd-ci-name">' + it.product_title + '</div>' + opt + eng +
        meta + '</div>' +
        '<div class="fd-ci-price">' + priceHtml + '</div></div>');
    });
    subEl.textContent = money(cart.total_price);
  }
  function refreshAndOpen() {
    fetch(CART + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); openCart(); })
      .catch(function () { window.location.href = CART; });
  }

  function handleAdd(form) {
    var input = form.querySelector('.eng-input');
    var btn = form.querySelector('[data-add]');
    var checked = form.querySelector('input[type="radio"]:checked');
    var engraved = checked && checked.value === 'engraved';
    var vid = engraved ? form.dataset.vidEngraved : form.dataset.vidPlain;
    if (!vid) { return; }
    if (engraved && input && !input.value.trim()) { input.focus(); input.style.borderColor = 'var(--persimmon)'; return; }
    var body = { items: [{ id: Number(vid), quantity: 1 }] };
    if (engraved && input && input.value.trim()) body.items[0].properties = { Engraving: input.value.trim() };
    // One free oil per board (matches the "every board ships with oil" promise).
    if (OIL_VID) body.items.push({ id: Number(OIL_VID), quantity: 1 });
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }
    fetch(CART + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { refreshAndOpen(); if (btn) { btn.removeAttribute('aria-busy'); btn.textContent = label; } })
      .catch(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.textContent = "Couldn't add — try again"; setTimeout(function () { btn.textContent = label; }, 2500); } });
  }

  // Delegated listeners — bound once to document, immune to section re-render.
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.closest) return;
    var form = t.closest('.ttb-fd .board-buy');
    if (form && t.matches('input[type="radio"]')) syncMode(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.ttb-fd .board-buy');
    if (form) { e.preventDefault(); handleAdd(form); }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.ttb-fd [data-cart-close]')) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initForms); } else { initForms(); }
  document.addEventListener('shopify:section:load', initForms);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
